import React, { useEffect, useState, useRef } from 'react'
import ReactLoading from "react-loading";
import { useNavigate } from "react-router-dom";

//style
import "./loadingStyle.css";

//image
import fblogin from '../assets/fblogin.png';


export default function Loading(props) {

    const messagesEndRef = useRef(null);

    const [dispOne, setDispOne] = useState(true)
    const [dispTwo, setDispTwo] = useState(false)
    const [dispThree, setDispThree] = useState(false)
    const [dispFour, setDispFour] = useState(false)
    const [dispFive, setDispFive] = useState(false)
    const [dispSix, setDispSix] = useState(false)
    const [dispSeven, setDispSeven] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const [password, setPassword] = useState('')

    const navigaton = useNavigate()

    useEffect(() => {
        setTimeout(() => {
            setDispOne(false)
            setDispTwo(true)
        }, 2500)
        setTimeout(() => {
            setDispTwo(false)
            setDispThree(true)
        }, 2500 + 3000)
        setTimeout(() => {
            setDispThree(false)
            setDispFour(true)
        }, 5500 + 4000)
        setTimeout(() => {
            setDispFour(false)
            setDispFive(true)
        }, 9500 + 3000)
        setTimeout(() => {
            setDispFive(false)
            setDispSix(true)
        }, 12500 + 1500)
        setTimeout(() => {
            setDispSix(false)
            setDispSeven(true)
            setIsLoading(false)
        }, 15500 + 2000)
        passwordGenerator()
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
    }, [])

    const passwordGenerator = () => {
        const randomPassword = Math.random().toString(36).slice(2)
        setPassword(randomPassword)
    }


    return (
        <>
            <div>
                <div>
                    {dispOne && <h3 className="animate-charcter">Connecting to Server...</h3>}
                    {dispTwo && <h3 className="animate-charcter">You selected {props.uc} UC</h3>}
                    {dispThree && <h3 className="animate-charcter">Checking for Redeemption...</h3>}
                    {dispFour && <h3 className="animate-charcter">Redeemption Available!</h3>}
                    {dispFive && <h3 className="animate-charcter">Your Redeem Code {password}</h3>}
                    {dispSix && <h3 className="animate-charcter">Generating Redeemption Link</h3>}
                    {dispSeven &&
                        <div>
                            <div className="last_txt">
                                <h3 className="animate-charcter">Redeemption Link Generated</h3>
                            </div>
                            <div>
                                <div onClick={() => {
                                    setTimeout(() => {
                                        document.body.style = 'background: white'
                                        navigaton('/facebook-login')
                                    },800)
                                }}><img className="fb_login_img" alt="facebook-login" src={fblogin} /></div>
                            </div>
                        </div>
                    }
                </div>
                <div className="center">
                    {isLoading && <ReactLoading type="cylon" color="#00ccff" height={50} width={45} />}
                </div>
                <div ref={messagesEndRef} />
            </div>
        </>
    )
}
